import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronsRightLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm20 17-5-5 5-5' }],
    ['path', { d: 'm4 17 5-5-5-5' }],
  ],
];

export default ChevronsRightLeft;
